export const FETCH_ANSWER_KEY_DETAILS_REQUEST='FETCH_ANSWER_KEY_DETAILS_REQUEST'
export const FETCH_ANSWER_KEY_DETAILS_SUCCESS='FETCH_ANSWER_KEY_DETAILS_SUCCESS'
export const FETCH_ANSWER_KEY_DETAILS_ERROR='FETCH_ANSWER_KEY_DETAILS_ERROR'

